import { useEffect, useLayoutEffect, useRef } from 'react';

export const useBeforeunload = (handler = (e: BeforeUnloadEvent) => {}) => {
	if (process.env.NODE_ENV !== 'production' && typeof handler !== 'function') {
		throw new TypeError(`Expected "handler" to be a function, not ${typeof handler}.`);
	}

	const handlerRef = useLatest(handler);

	useEffect(() => {
		const handleBeforeunload = (event: BeforeUnloadEvent) => {
			let returnValue: any;

			if (typeof handlerRef.current === 'function') {
				returnValue = handlerRef.current(event);
			}

			if (event.defaultPrevented) {
				event.returnValue = '';
			}

			if (typeof returnValue === 'string') {
				event.returnValue = returnValue;
				return returnValue;
			}
		};

		window.addEventListener('beforeunload', handleBeforeunload);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeunload);
		};
	}, [handlerRef]);
};

// export function useImperitiveDirtyState() {
// 	const api = useContext(DirtyContext);

// 	return api;
// }

// /** @deprecated use DirtyState component directly */
// export function useDirtyState(key: string, dirtyMessage: string | '') {
// 	const { setDirty } = useImperitiveDirtyState() ?? {};
// 	useEffect(() => setDirty?.(key, dirtyMessage), [dirtyMessage, key, setDirty]);
// }

export const useLatest = <T = unknown>(value: T) => {
	const ref = useRef(value);
	useLayoutEffect(() => {
		ref.current = value;
	}, [value]);
	return ref;
};
